import { render, staticRenderFns } from "./Harder.vue?vue&type=template&id=6a70c776&scoped=true&"
import script from "./Harder.vue?vue&type=script&lang=js&"
export * from "./Harder.vue?vue&type=script&lang=js&"
import style0 from "./Harder.vue?vue&type=style&index=0&id=6a70c776&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70c776",
  null
  
)

export default component.exports